import {
  AfterViewInit,
  Component,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { UserLoginService } from '../../../shared/services/user-login.service';
import { CognitoUtil } from '../../../shared/utils/cognito.service';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { SiteManagementService } from 'src/app/site-management/site-management.service';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { LoaderService } from 'src/app/shared/utils/loader.service';
import { SizeDetectorService } from 'src/app/shared/utils/size-detector.service';
import { AccountSettingsComponent } from '../account-settings/account-settings.component';
import { HelperService } from 'src/app/shared/utils/helper.service';
import LoginRoutingPath from 'src/app/login/login-routing-path';
import {
  IUser,
  IUserProfile,
} from 'src/app/user-management/user-management-interfaces';
import { AccountSettingsService } from '../account-settings/account-setting.service';
import { UserProfileComponent } from 'src/app/user-management/user-profile/user-profile.component';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { BRANDS } from 'src/app/shared/models/screen-size.enum';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';

@Component({
  selector: 'app-mobile-header',
  templateUrl: './mobile-header.component.html',
  styleUrls: ['./mobile-header.component.scss'],
})
export class MobileHeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  subscription: Subscription | undefined;
  sharedData: any;
  CONSTANTS = CONSTANTS;
  siteId!: string;
  navLogo: string = CONSTANTS.KWIKSET_UNITE_LOGO;

  @Input() user!: Observable<IUser | undefined>;
  @Input() itemList: any[] = [];
  @Input() profileDetails!: IUserProfile;

  constructor(
    private router: Router,
    public userService: UserLoginService,
    public cognitoUtil: CognitoUtil,
    public sharedDataService: SharedDataService,
    private siteManagementService: SiteManagementService,
    private loaderService: LoaderService,
    private helperService: HelperService,
    private accountSettingService: AccountSettingsService,
    private stateManagementService: StateManagementService
  ) {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {
    this.subscription = this.sharedDataService.currentData.subscribe(
      (sharedData) => {
        this.sharedData = sharedData;
      }
    );
    this.setImageByBrand();
  }

  setImageByBrand(): void {
    const brandName = this.stateManagementService.getUserBrand();
    this.navLogo = brandName === BRANDS.KWIKSETUNITE ? CONSTANTS.KWIKSET_UNITE_LOGO : CONSTANTS.WEISER_UNITE_LOGO;
  }

  ngAfterViewInit(): void {
    const URL = window.location.pathname;
    if (URL.includes('dashboard'))
      this.sharedDataService.setHeaderTab(CONSTANTS.DASHBOARD);
    else if (URL.includes('site-management'))
      this.sharedDataService.setHeaderTab(CONSTANTS.LOCATIONS);
    else if (URL.includes('users'))
      this.sharedDataService.setHeaderTab(CONSTANTS.USERS);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  onSelected(selected: string) {
    this.sharedDataService.setHeaderTab(selected);
    if (selected === CONSTANTS.DASHBOARD) this.router.navigate(['/dashboard']);
    else if (selected === CONSTANTS.LOCATIONS)
      this.router.navigate(['/site-management']);
    else if (selected === CONSTANTS.USERS) this.router.navigate(['/users']);
  }

  logout() {
    this.loaderService.show();
    this.sharedDataService.resetSharedData();
    this.userService.logout().subscribe({
      next: (res: any) => {
        this.loaderService.hide();
        this.router.navigate([LoginRoutingPath.loginForm]);
      },
      error: (err: Error) => {},
    });
  }

  /**
   * @description: this function is to redirect account setting modal.
   * @returns void
   */
  viewAccountSetting(): void {
    const dialogInstance = this.helperService.openModalDialog(
      AccountSettingsComponent,
      { enableBackOperation: false, defaultNavigation: CONSTANTS.BUILDING },
      [CONSTANTS.FIXED_SCREEN_MODAL, CONSTANTS.SPACE_ZERO]
    );
  }

  /**
   * @description: this function is to redirect user profile view modal.
   * @returns void
   */

  viewUserProfile(): void {
    const dialogInstance = this.helperService.openModalDialog(
      UserProfileComponent,
      {
        enableBackOperation: false,
        defaultNavigation: CONSTANTS.BUILDING,
        profileDetails: this.profileDetails,
        ownProfile: true,
        userId: this.stateManagementService.getUser().userId,
        siteTimeZone: this.sharedData?.selectedSite?.siteTimeZone,
      },
      [CONSTANTS.FIXED_SCREEN_MODAL, CONSTANTS.SPACE_ZERO]
    );
  }
  helpFaqs(): void {
    const brand = this.stateManagementService?.getUserBrand();
    const Lang = this.stateManagementService?.getUserLanguage();
    if(brand === BRANDS.WEISER){
      if(Lang === LANG_CONST.FRENCH) {
        window.open(CONSTANTS.HELP_LINK_FRENCH_WEISER, '_blank');
      }
      else {
        window.open(CONSTANTS.HELP_LINK_WEISER, '_blank');
      }
    }
    else {
      window.open(CONSTANTS.HELP_AND_FAQ_LINK, '_blank');
    }
  }
}
